import type { Role, Workplace } from "./types";

export const ROLE_LABELS: Record<Role, string> = {
  finance_admin: "Финансовый администратор",
  finance_controller: "Финансовый контролер",
  cost_center_owner: "Ответственный кост-центра",
  business_initiator: "Бизнес-инициатор",
  functional_owner: "Функциональный владелец",
  approver: "Согласующий",
  observer: "Наблюдатель"
};

export const WORKPLACE_META: Record<Workplace, { title: string; eyebrow: string; subtitle: string; action: string }> = {
  dashboard: {
    eyebrow: "Рабочее место",
    title: "Рабочий стол",
    subtitle: "Главные задачи, статусы кампании и уведомления по вашему контуру.",
    action: "Обновить данные"
  },
  campaigns: {
    eyebrow: "Настройка кампаний",
    title: "Бюджетные кампании",
    subtitle: "Периоды подачи, доступные формы и активная версия бюджетной кампании.",
    action: "Сохранить кампанию"
  },
  upload: {
    eyebrow: "Импорт Excel",
    title: "Загрузка и очередь",
    subtitle: "Проверка шаблона, постановка файлов в очередь и разбор ошибок импорта.",
    action: "Поставить в очередь"
  },
  admin: {
    eyebrow: "Справочники",
    title: "Справочники и сопоставление",
    subtitle: "Статьи, кост-центры, пользователи, mapping, аллокации и бизнес-измерения.",
    action: "Открыть справочники"
  },
  allocation_basis: {
    eyebrow: "Управление распределением",
    title: "База распределения",
    subtitle: "Проверка расчета, подтверждение владельцем и ввод в действие финансовым контролером.",
    action: "Обновить базу"
  },
  manual_request: {
    eyebrow: "Подача данных",
    title: "Ручная заявка",
    subtitle: "Доходы блока A, расходы, CAPEX, пояснительные и многострочные заявки.",
    action: "Создать заявку"
  },
  workflow: {
    eyebrow: "Процесс",
    title: "Заявки, проверки и версии",
    subtitle: "Очередь согласования, карточки заявок, центр проверок и сравнение версий.",
    action: "Обновить заявки"
  },
  budget: {
    eyebrow: "Рабочая сборка",
    title: "Бюджет",
    subtitle: "Сборка бюджетной кампании из поданных заявок, preview итогов и шаблонный вид.",
    action: "Пересчитать бюджет"
  },
  reports: {
    eyebrow: "Отчетность",
    title: "Отчеты и детализация",
    subtitle: "Строки бюджета, бюджет кост-центра, своды A/C и объяснение сумм.",
    action: "Применить фильтры"
  },
  sheets: {
    eyebrow: "Excel-вид",
    title: "Заполненные таблицы",
    subtitle: "Привычная сетка Excel с карточками ячеек, детализацией и системными действиями.",
    action: "Обновить таблицу"
  },
  exports: {
    eyebrow: "Выгрузки",
    title: "Экспорты",
    subtitle: "Консолидированный бюджет, KPI и выгрузки с текущими фильтрами.",
    action: "Скачать Excel"
  },
  ui_kit: {
    eyebrow: "Дизайн-система",
    title: "UI kit",
    subtitle: "Внутренний стенд базовых состояний светлого интерфейса для проверки сборки.",
    action: "Проверить состояния"
  }
};

export const STATUS_LABELS: Record<string, string> = {
  draft: "Черновик",
  submitted: "Подана",
  in_review: "На проверке",
  pending_approval: "На согласовании",
  returned: "Возвращена",
  approved: "Утверждена",
  correction: "Корректировка",
  archived: "Архив",
  rolled_back: "Откат выполнен",
  open: "Открыта",
  closed: "Закрыта",
  error: "Ошибка",
  warning: "Предупреждение",
  resolved: "Закрыта",
  finance_review: "финансовая проверка",
  owner_review: "проверка владельца",
  approver_review: "согласование",
  import_review: "проверка импорта"
};

export const REQUEST_TYPE_LABELS: Record<string, string> = {
  revenue: "Доходы",
  opex: "Расходы",
  capex: "CAPEX",
  manual_budget: "Универсальная",
  manual_request: "Ручная заявка",
  revenue_request: "Доходная заявка",
  explanation_note: "Пояснительная",
  budget_version: "Версия бюджета"
};

export const TEMPLATE_LABELS: Record<string, string> = {
  auto: "Определить автоматически",
  compiled_budget: "Бюджет кост-центра",
  business_variant_1: "Бизнес-вариант 1",
  business_variant_2: "Бизнес-вариант 2",
  explanation_note: "Пояснительная записка",
  summary_c: "Свод C"
};

export const COMPLETION_AUDIT_LABELS = [
  "Vite white UI",
  "Ручная бюджетная заявка",
  "Форма пояснительной записки",
  "Доходная заявка блока A",
  "Excel Summary A",
  "Excel Summary C",
  "Шаблон бизнес V2"
];
